"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Hint_1 = require("../../../../common/Hint");
var DebtorTilesContainer_1 = require("../Debtor/DebtorTilesContainer");
var scrollToTop_1 = require("../../../../../utils/scrollToTop");
var wizardNavigationButtons_1 = require("../../wizardNavigationButtons");
var core_1 = require("@rradar/core");
var DebtorSearch = function (props) {
    (0, scrollToTop_1.default)();
    var handleRemoveDebtor = function () {
        props.setSelectedDebtor({ id: null });
        props.setDebtor(props.setFieldValue, props.debtor, props.values, props.BOEInterestRate);
    };
    return (React.createElement("div", { className: "add-debt-wizard-page flex-column" },
        React.createElement("div", { className: "add-debt-wizard-form-contents" },
            React.createElement("div", { className: "wizard-form-description" },
                React.createElement("h2", null, "Debtor Search"),
                React.createElement("p", null, "To save you some time, if you have already used the details of a debtor previously, you can search for them and select them on this page."),
                React.createElement("p", null,
                    "This will auto-select the debtor's type (if they are an individual or business) on the next page, and automatically fill in their details on the debtor page.",
                    ' ',
                    React.createElement(Hint_1.default, { id: "" }, "A debtor is the person or organisation that - in relation to your business - owes you money"))),
            React.createElement("div", { className: "flex-row-wrap" },
                React.createElement("input", { type: "text", placeholder: "Enter a debtor's name", value: props.search_text, onChange: function (e) {
                        props.searchAndPopulateDebtors(e.target.value, props.setFieldValue, props.values);
                    } })),
            props.debtor.id !== null ? (React.createElement(core_1.Button, { buttonType: "primary", onClick: handleRemoveDebtor }, "Remove Selected Debtor")) : null,
            React.createElement(DebtorTilesContainer_1.default, { debtors: props.debtors, setDebtor: props.setDebtor, values: props.values, setFieldValue: props.setFieldValue, setSelectedDebtor: props.setSelectedDebtor, selectedDebtor: props.debtor, BOEInterestRate: props.BOEInterestRate })),
        React.createElement(wizardNavigationButtons_1.default, { previousPath: '/dashboard/debtwizard/page1', nextPath: '/dashboard/debtwizard/page3' })));
};
exports.default = DebtorSearch;
